import { render, staticRenderFns } from "./MSDLN2023.vue?vue&type=template&id=4fa97cee&scoped=true"
import script from "./MSDLN2023.vue?vue&type=script&lang=js"
export * from "./MSDLN2023.vue?vue&type=script&lang=js"
import style0 from "./MSDLN2023.vue?vue&type=style&index=0&id=4fa97cee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa97cee",
  null
  
)

export default component.exports